// extracted by mini-css-extract-plugin
export default {"tags":"tags__cPnJu3rYaN9N","suiList":"suiList__mRam_GgWUQy9"};